import { Product } from '@core/models/piramide/Product';

export class Cpu extends Product {
  $caracteristicas: {
    familia: string;
    L1?: number;
    L2?: number;
    L3?: number;
    cantidad?: number;
    cate_cpu?: number;
    chipset_gpu?: string;
    clock?: number; //
    cooler: number;
    cores?: number; //
    fecha_update?: string;
    hilos?: number;
    id_producto: number;
    modelo: string; //
    nivel_cpu_deprecado?: number;
    nivel_gpu?: number;
    tecnologia: number | string;
    tipo: string; //
    turbo?: number;
    w: number; //
  };
  public constructor(product: Product) {
    super(product);
    if (product.id_subcategoria !== 48 && product.id_subcategoria !== 27) {
      throw 'esto no es un cpu';
    }
  }
}
